export default __webpack_public_path__ + "static/media/TokenPocket.0ba48742.svg";